<template>
  <div style='background: #fff;'>
    <div v-if="commentData.length > 0" class="comment"
       :class="type == 'notice' && isBtn && bottomBar ? 'pb-100' : isBtn ? 'pb-50' : 'pb-15'">
      <div class="sub-title">{{ $t("global.comment") }}</div>
      <van-row v-for="(item, i) in commentData" :key="i" :id="'comment-' + item.id" class="mb-15">
        <div class="flex">
          <van-image round width="32px" height="32px" :src="item.avatar" />
          <div class="flex1 content-1 ml-10">
            <div class="flex mt-2">
              <div class="name-1 flex1">{{ item.name }}</div>
              <div span="7" class="time-1">{{ item.updated_at }}</div>
            </div>
            <div class='mt-5' v-html="item.content"></div>
            <div>
              <div class="mt-10" v-if="item.imgUrl.length > 0">
                <van-uploader v-model="item.imgUrl" :deletable="false" :show-upload="false" preview-size="80"></van-uploader>
              </div>
              <div class="mt-10" v-if="item.videoUrl.length > 0">
                <div v-for="(list, i) in item.videoUrl" :key="i">
                  <div v-if="list.video_convert_status == 0" class="pdfList flex">
                    <img src="@/assets/link.png" alt="" class="pdfImg" />
                    <a class="ml-10 color3 flex1" :href="list.url">{{ $t("contact.Convert") }}</a>
                  </div>
                  <video v-else :src="list.url" controls :poster="list.video_cover" muted preload="auto" style="width: 100%; height: 100%; fit: fill"></video>
                </div>
              </div>
              <div class="pdfList flex" v-for="(list, index) in item.pdfUrl" :key="index">
                <!-- <img src="@/assets/PDF.png" alt="" class="pdfImg"  /> -->
                <img src="@/assets/PDF.png" alt="" class="pdfImg" v-if="list.mimetype == 'application/pdf'" />
                <img src="@/assets/excel.png" alt="" class="pdfImg" v-else-if="list.mimetype == 'application/vnd.ms-excel' || list.mimetype == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" />
                <img src="@/assets/word.png" alt="" class="pdfImg" v-else-if="list.mimetype == 'application/msword' || list.mimetype == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" />
                <img src="@/assets/zip.png" alt="" class="pdfImg" v-else-if="list.mimetype == 'application/x-zip-compressed'" />
                <img src="@/assets/link.png" alt="" class="pdfImg" v-else />
                <a class="ml-10 color3 flex1" :href="list.url">{{ list.title }}</a>
              </div>
            </div>
            <div class='fromTo' v-if="item.from">{{ item.from }}</div>
          </div>
        </div>
      </van-row>
    </div>
    <van-button type="default" round icon="chat-o" size="small" class="comment-btn" :class="bottomBar ? 'bottom-2' : 'bottom-1'" @click="scrllToBottom" v-if="isBtn">{{ $t("global.comment") }}</van-button>
    <div v-else :class="commentData.length == 0 ? 'borderTop' : ''">
      <!-- v-if="type == 'notice'" -->
      <div class='comment-box'>
        <div class="bottomText">
          <span><van-icon name="info-o" /> {{ $t("global.comments_teacher") }}</span>
        </div>
        <div class="uploadList">
          <div class="imgScroll" ref="imgScrollContainer">
            <van-uploader v-model="qiniuFile" :show-upload="false" :before-delete="delImg" preview-size="60" v-if="qiniuFile.length > 0" class="imgList"></van-uploader>
          </div>
          <div v-if="qiniuDataPdf.length > 0">
            <div class="color6 flex font13 items-center filePdf" v-for="(list, ix) in qiniuDataPdf" :key="ix">
              <img src="@/assets/PDF.png" alt="" class="pdfImg" v-if="list.mimetype == 'application/pdf'" />
              <img src="@/assets/excel.png" alt="" class="pdfImg" v-else-if="list.mimetype == 'application/vnd.ms-excel' || list.mimetype == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'" />
              <img src="@/assets/word.png" alt="" class="pdfImg" v-else-if="list.mimetype == 'application/msword' || list.mimetype == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" />
              <img src="@/assets/zip.png" alt="" class="pdfImg" v-else-if="list.mimetype == 'application/x-zip-compressed'" />
              <img src="@/assets/video.png" alt="" class="pdfImg" v-else-if="list.mimetype && list.mimetype.startsWith('video/')" />
              <img src="@/assets/link.png" alt="" class="pdfImg" v-else />
              <a class="flex1 ml-4 color6" :href="list.file_key">{{ list.title }}</a>
              <van-icon name="edit" size="18" class="mr-10" v-if="list.file_key != ''" @click="editTitle(list, ix)" />
              <van-icon name="delete-o" size="18" v-if="list.file_key != ''" @click="delPdf(list, ix)" />
            </div>
          </div>
        </div>
        <div class="flex">
          <div class="comment-input flex1">
            <van-field v-model="content" rows="2" :autosize="{ minHeight: 50, maxHeight: 150 }" label="" type="textarea" ref="textareaInput" maxlength="5000" :placeholder="$t('global.please_input')" show-word-limit @focus="onTextareaFocus" />
          </div>
        </div>
       <div class="sendText">
          <van-uploader :after-read="afterRead" class="mt-10" multiple :max-size="1024 * 1024 * 500" @oversize="onOversize" accept="image/*,.pdf,.doc,.docx,.zip,.xls,.xlsx,video/*">
            <span class="iconfont iconfont-link"></span>
          </van-uploader>
          <div class="btn">
            <van-button round type="default" size="small" class='mr-10' @click="isBtn=true">{{ $t("global.cancel") }}</van-button>
            <van-button round type="info" size="small" v-if="content != '' || uploadList.length != 0 || qiniuDataPdf.length != 0" @click="commit" :loading="disabledSend">{{ $t("global.submit") }}</van-button>
            <van-button round type="info" size="small" v-else disabled>{{ $t("global.submit") }}</van-button>
          </div>
        </div>
      </div>
      <!-- <div v-else>
        <div class="comment-input">
          <van-field v-model="content" rows="2" autosize label="" type="textarea" ref="textareaInput" maxlength="5000" :placeholder="$t('global.please_input')" show-word-limit />
        </div>
        <div style="text-align: right" class="bottomFlex mt-10" :class="bottomBar ? 'mb-2' : 'mb-1'">
          <span class="flex1 color9"><van-icon name="info-o" /> {{ $t("global.comments_teacher") }}</span>
          <van-button round type="info" size="small" class="flexWidth" style="padding: 0 20px" :loading="loading" @click="commit">{{ $t("global.submit") }}</van-button>
        </div>
      </div> -->
    </div>
    <van-dialog v-model="titleShow" title="重命名" show-cancel-button :before-close="beforeClose">
      <div class="rename">
        <van-field v-model="title" rows="2" autosize type="textarea" class="textarea" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { Field, Toast, Uploader, Dialog } from "vant";
import { commentList, commentSave } from "@/api/comment";
import * as qiniu from "qiniu-js";
import { getQiniuToken, deleteFile, updateFileTitle, getQiniuVideoToken } from "@/api/contactCampus";
Vue.use(Field);
Vue.use(Toast);
Vue.use(Uploader);
Vue.use(Dialog);

export default {
  name: "Comment",
  props: {
    id: String,
    type: String,
    childid: Number,
    bottomBar: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    commentId: {
      type: [String, Number],
      default: "",
    },
  },
  watch: {
    childid(val) {
      this.child_id = val;
    },
    isBtn(val) {
      this.$emit('input-focus', !val);
    },
    content() {
      setTimeout(() => {
        this.getInitHeight();
      }, 50);
    },
  },
  data() {
    return {
      loading: false,
      isBtn: true,
      content: "",
      commentData: [],
      child_id: "",
      Token: "",
      videoToken: "",
      qiniuFile: [],
      qiniuDataUrl: [],
      qiniuDataPdf: [],
      uploadList: [],
      attachmentList: {},
      titleShow: false,
      editList: {},
      editIndex: null,
      title: "",
      confirmBtn: false,
      files: [],
      countIndex: 0,
      showFiles: [],
      uploadStatus: true,
      disabledSend: false,
    };
  },
  created() {
    this.fetchData();
    this.getQiniu();
    this.getQiniuVideo();
  },
  methods: {
    getInitHeight() {
      this.$nextTick(() => {
        var box = this.$parent.$refs.contentBox;
        var maxScroll =document.documentElement.scrollHeight+500;
        document.documentElement.scrollTop = maxScroll;
        document.body.scrollTop = maxScroll;
        window.scrollTo(0, maxScroll);
        if (box) box.scrollTop = maxScroll;
        box.scrollIntoView({ block: "end" });
      });
    },
    onTextareaFocus() {
      setTimeout(() => {
        this.$nextTick(() => {  
          var box = this.$parent.$refs.contentBox;
          var maxScroll = box ? box.scrollHeight : document.documentElement.scrollHeight;
          document.documentElement.scrollTop = maxScroll;
          document.body.scrollTop = maxScroll;
          window.scrollTo(0, maxScroll);
          if (box) box.scrollTop = maxScroll;
        });
      }, 50);
    },
    scrllToBottom() {
      this.isBtn = false;
      // 必须在用户点击的同步调用栈中 focus，否则微信 webview 无法弹出键盘
      this.$nextTick(() => {
        var inputEl = this.$refs.textareaInput.$el.querySelector('textarea') || this.$refs.textareaInput.$refs.input;
        if (inputEl) {
          inputEl.focus();
        }
        // 聚焦后再异步滚动
        setTimeout(() => {
          var container = document.querySelector("#app");
          var maxScroll = Math.max(container.scrollHeight, document.documentElement.scrollHeight, document.body.scrollHeight);
          container.scrollTo(0, maxScroll);
          window.scrollTo(0, maxScroll);
          document.documentElement.scrollTop = maxScroll;
          document.body.scrollTop = maxScroll;
        }, 300);
      });
    },
    scrollToComment() {
      var el = document.getElementById("comment-" + this.commentId);
      if (el) {
        el.scrollIntoView({ block: "start" });
      }
    },
    fetchData() {
      this.child_id = this.childid;
      commentList(this.type, this.id).then((res) => {
        res.data.item.forEach((list) => {
          list.imgUrl = [];
          list.pdfUrl = [];
          list.videoUrl = [];
          if (list.attachments.length != 0) {
            list.attachments.forEach((item) => {
              let type = res.data.attachmentList[item].mimetype.split("/")[0];
              if (type == "image") {
                list.imgUrl.push({ url: res.data.attachmentList[item].url });
              } else if (type == "video") {
                list.videoUrl.push(res.data.attachmentList[item]);
              } else {
                list.pdfUrl.push(res.data.attachmentList[item]);
              }
            });
          }
        });
        this.commentData = res.data.item;
        this.$emit("change", res.data.item);
        if (this.commentId) {
          this.$nextTick(() => {
            this.scrollToComment();
          });
        }
      });
    },
    commit() {
      if (!this.uploadStatus) {
        Toast(this.$t("contact.Uploading"));
        return;
      }
      this.disabledSend = true;
      var ids = [];
      this.uploadList.forEach((item) => {
        ids.push(item._id);
        this.attachmentList[item._id] = {
          url: item.file_key,
          id: item._id,
          mimetype: item.mimetype,
          title: item.title,
        };
      });
      this.qiniuDataPdf.forEach((item) => {
        ids.push(item._id);
        this.attachmentList[item._id] = {
          url: item.file_key,
          id: item._id,
          mimetype: item.mimetype,
          title: item.title,
        };
      });
      this.loading = true;
      commentSave({
        id: this.id,
        type: this.type,
        child_id: this.child_id,
        content: this.content,
        attachments: ids,
      }).then(() => {
        this.fetchData();
        this.qiniuDataPdf = [];
        this.uploadList = [];
        this.qiniuFile = [];
        this.content = "";
        this.isBtn = true;
        this.loading = false;
        this.disabledSend = false;
      });
    },
    // 统一获取 token 方法
    getToken(type) {
      const api = type === "video" ? getQiniuVideoToken : getQiniuToken;
      return new Promise((resolve, reject) => {
        api({ linkId: this.id, linkType: this.type })
          .then((res) => {
            if (type === "video") {
              this.videoToken = res.data;
            } else {
              this.Token = res.data;
            }
            resolve(res);
          })
          .catch((e) => reject(e));
      });
    },
    getQiniu() {
      return this.getToken(); // 默认为普通 token
    },
    getQiniuVideo() {
      return this.getToken("video");
    },
    sendQiniu() {
      if (this.countIndex >= this.files.length) {
        this.uploadStatus = true;
        return;
      }
      this.uploadStatus = false;
      const fileItem = this.files[this.countIndex];
      const fileType = fileItem.file.type.split("/")[0]; // 只取主类型：image / video / application ...
      const isImage = fileType === "image";
      const isVideo = fileType === "video";
      const config = { useCdnDomain: true, region: qiniu.region.z1 };
      const putExtra = { fname: fileItem.file.name, params: {}, mimeType: null };
      const key = fileItem.file.name;
      // 判断是图片还是文档列表
      const list = isImage ? this.qiniuFile : this.qiniuDataPdf;
      const lenDiff = list.length - this.files.length;
      const lens = lenDiff === 0 ? this.countIndex : lenDiff + this.countIndex;
      if (isImage) {
        this.$set(list[lens], "message", this.$t("contact.Uploading"));
      } else {
        this.$set(list[lens], "title", this.$t("contact.Uploading"));
        this.$set(list[lens], "file_key", "");
      }

      this.$nextTick(() => {
        setTimeout(() => this.scrllToBottom(), 100);
      });

      const observe = {
        next: () => {},
        error: () => {
          this.getToken(isVideo ? "video" : "")
            .then(() => this.sendQiniu())
            .catch(() => {
              console.error("Token 获取失败，上传终止");
            });
        },
        complete: (res) => {
          if (isImage) {
            this.uploadList.push(res.data);
            this.$set(list[lens], "url", res.data.file_key);
            this.$set(list[lens], "status", "done");
            this.$set(list[lens], "name", res.data.title);
            this.$nextTick(() => {
              this.scrollImgToRight();
            });
          } else {
            this.$set(list, lens, res.data);
          }
          this.countIndex++;
          this.sendQiniu();
        },
      };
      const token = isVideo ? this.videoToken : this.Token;
      const headers = qiniu.getHeadersForMkFile(token);
      const observable = qiniu.upload(fileItem.file, key, token, headers, putExtra, config);
      this.subscription = observable.subscribe(observe);
    },
    scrollImgToRight() {
      var el = this.$refs.imgScrollContainer;
      if (el) {
        el.scrollLeft = el.scrollWidth;
      }
    },
    onOversize() {
      Toast(this.$t("contact.keep_below"));
    },
    afterRead(file) {
      if (Array.isArray(file)) {
        this.files = file;
      } else {
        this.files = [file];
      }
      let type = this.files[0].file.type.split("/");
      // this.files.some(ele=>(alert(ele.file.name)))
      if (type[0] == "image") {
        let arr = this.qiniuFile.filter((item) => this.files.some((ele) => ele.file.name === item.name));
        if (arr.length > 0) {
          Toast(this.$t("contact.Data_duplication"));
          return;
        }
      }
      this.files.forEach((item) => {
        let type = item.file.type.split("/");
        if (type[0] == "image") {
          this.qiniuFile.push({ url: "", status: "uploading", message: this.$t("contact.Upload_queue") });
        } else {
          this.qiniuDataPdf.push({
            title: this.$t("contact.Upload_queue"),
            file_key: "",
          });
        }
      });
      this.countIndex = 0;
      this.sendQiniu();
      this.$nextTick(() => {
        this.scrollImgToRight();
      });
    },
    delImg(file, detail) {
      deleteFile(this.uploadList[detail.index]._id).then(() => {
        this.uploadList.splice(detail.index, 1);
        this.qiniuFile.splice(detail.index, 1);
      });
    },
    delPdf(list, index) {
      deleteFile(list._id).then(() => {
        this.qiniuDataPdf.splice(index, 1);
      });
    },
    editTitle(list, index) {
      this.editList = list;
      this.editIndex = index;
      this.titleShow = true;
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        if (this.title == "") {
          Toast(this.$t("global.please_input"));
          done(false);
          return;
        }
        this.confirmBtn = true;
        updateFileTitle({ id: this.editList._id, title: this.title }).then((res) => {
          if (res.code == 0) {
            this.qiniuDataPdf[this.editIndex].title = res.data.title;
            this.qiniuDataPdf[this.editIndex].file_key = res.data.url;
            this.titleShow = false;
            this.confirmBtn = false;
            done();
          } else {
            this.confirmBtn = false;
            done();
          }
        });
      } else {
        this.titleShow = false;
        done();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.flex1 {
  min-width: 0;
}
.pb-100 {
  padding-bottom: 100px;
}
.borderTop {
  border-top: 15px solid #f7f8fa;
  background: #fff;
}
.comment {
  background: #fff;
  padding-top: 18px;
  padding-left: 15px;
  padding-right: 15px;
  border-top: 15px solid #f7f8fa;
}
.sub-title {
  font-size: 15px;
  font-weight: bold;
  color: #323233;
  margin-bottom: 15px;
}
.name-1 {
  // line-height: 30px;
  font-size: 14px;
  font-weight: 400;
  color: #646566;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.time-1 {
  // line-height: 30px;
  font-size: 12px;
  font-weight: 400;
  color: #646566;
  text-align: right;
}
.content-1 {
  font-size: 14px;
  font-weight: 400;
  color: #323233;
  line-height: 20px;
}
.mt-2{
  margin-top:2px;
}
.comment-btn {
  position: fixed;
  right: 16px;
  box-shadow: 0px 2px 8px 0px rgb(0 0 0 / 20%);
}
.bottom-1 {
  bottom: 20px;
}
.bottom-2 {
  bottom: 66px;
}
.mb-2 {
  // padding-bottom: 60px;
}
.comment-input {
  background-color: #f2f3f5;
  border-radius:8px;
  .van-cell {
    background-color: transparent;
  }
}
.bottomFlex {
  display: flex;
  .flex1 {
    flex: 1;
    text-align: left;
    font-size: 12px;
    line-height: 32px;
    color: #646566;
  }
}
.comment-box{
  padding: 12px;
  background: #fff;
  border:1px solid #1989FA;
  border-radius: 8px;
  margin:12px 8px 16px 8px;
}
.bottomText {
  text-align: left;
  font-size: 12px;
  margin-bottom:12px;
  color: #646566;
}
.sendText {
  margin-top: 10px;
  position: relative;
  min-width: 55px;
  .iconfont {
    margin-top: 12px;
    font-size: 17px;
    margin-left:5px
  }
  .btn {
    position: absolute;
    bottom: 0;
    right: 0;
    button{
      min-width:50px
    }
  }
}
.uploadList {
  .imgScroll {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    /deep/ .van-uploader__wrapper {
      display: inline-flex;
      flex-wrap: nowrap;
      .van-uploader__preview{
        margin:0
      }
      .van-uploader__preview:not(:first-child){
        margin: 0 0 8px 8px;
      }
    }
  }
  .filePdf {
    margin: 8px 0;
    // background: #f2f3f5;
    padding: 2px 8px;
    border-radius: 6px;
    align-items: center;
    border: 1px solid #EBEDF0;
    color: #646566;
    .pdfImg{
      height: 18px;
      width: 18px;
    }
    .iconfont {
      font-size: 14px;
    }
    a {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin: 7px 10px;
    }
  }
}
.rename {
  margin: 8px 24px;
  .textarea {
    background: #f7f8fa;
    border-radius: 8px;
  }
}
.fromTo{
  font-size: 12px;
  color: #646566;
  margin-top:8px
}
.pdfList {
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #EBEDF0;
  font-size: 14px;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 0;
  img {
    height: 22px;
    width: 22px;
  }
  a {
    line-height: 22px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>

<style>
.van-image--round img {
  object-fit: cover;
}
</style>
